import React, { useMemo } from "react";
import { isExternalUrl } from "@src/utils";
import { FormBlock as FormBlockShared } from "@shared/src";

interface FormBlockProps {
  title: string | React.ReactNode;
  typeStr?: string;
  content: React.ReactNode;
  etc?: React.ReactNode;
}

export const FormWrap = ({ children }: { children: React.ReactNode }) => {
  return (
    <form onSubmit={(e) => e.preventDefault()} className="form-wrap" noValidate>
      {children}
    </form>
  );
};

export const FormBlock = ({ title, typeStr, content, etc }: FormBlockProps) => {
  return (
    // <div className="form-block">
    //   <div className="form-title">
    //     <div className="title">{title}</div>
    //     {typeStr && (
    //       <div className="necessary">
    //         <span>*</span>
    //         {typeStr}
    //       </div>
    //     )}
    //   </div>
    //   <div className="form-content">{content}</div>
    //   {etc && etc}
    // </div>
    <FormBlockShared
      title={title}
      typeStr={typeStr}
      content={content}
      etc={etc}
      className="form-block"
    />
  );
};

export const FormLinkBlock = ({
  title = "",
  link = "",
  content = "",
  linkable = true,
}: {
  title?: string;
  content?: string | React.ReactNode;
  link?: string;
  linkable?: boolean;
}) => {
  return (
    <div
      className="form-link-block"
      onClick={(e) => {
        if (linkable) {
          window.location.href = isExternalUrl(`${link}`);
        }
      }}
    >
      <span className="title">{title}</span>
      <span className="desc">{content}</span>
      {linkable && <span className="icon icon-chevron-right-18-gray900"></span>}
    </div>
  );
};
